module.exports = __webpack_public_path__ + "img/payment_pc_03.3728d1d7.png";